export SlideLeft from './slide-left';
export SlideRight from './slide-right';
export ZoomIn from './zoom-in';
export ZoomOut from './zoom-out';
